import React from "react";
import {Box, CircularProgress, Switch, Typography} from "@mui/material";
import {useDispatch} from "react-redux";
import _ from "lodash";
import styles from "../../organizationMainStyles";
import {accessibilityMode} from "../organizationSettingsConstants";
import {organizationSettingsActions} from "_actions";
import {TRENDS_ORGANIZATION_SETTING_GROUPS} from "./trendsOrganizationSettingsConfig";

export default function TrendsOrganizationSettingsContainer({
    mode,
    organizationTrendsId,
    label,
    trendsOrganization,
    loading,
    updatingField,
}) {
    const disable = mode === accessibilityMode.READ_ONLY;
    const dispatch = useDispatch();

    if (!organizationTrendsId) {
        return (
            <Box sx={style.unavailable}>
                <Typography sx={style.unavailableText}>{label.TRENDS_SETTINGS_UNAVAILABLE}</Typography>
            </Box>
        );
    }

    const handleToggle = (field) => (event) => {
        const value = _.get(event, 'target.checked');
        dispatch(organizationSettingsActions.updateTrendsOrganizationSetting(organizationTrendsId, field, value));
    };

    if (loading) {
        return (
            <Box sx={styles.bodyLoading}>
                <CircularProgress size={28} sx={styles.bodyLoadingSpinner} />
            </Box>
        );
    }

    return (
        <Box sx={style.groups}>
            {TRENDS_ORGANIZATION_SETTING_GROUPS.map((group) => (
                <Box key={group.title} sx={style.group}>
                    <Typography component="h3" sx={style.groupTitle}>
                        {group.title}
                    </Typography>
                    <Box sx={style.groupToggles}>
                        {group.settings.map((setting) => (
                            <Box key={setting.key} sx={styles.notificationToggleContainer}>
                                <Box component="span" sx={styles.notificationToggleLabel}>
                                    {setting.label}
                                </Box>
                                <Switch
                                    disabled={disable || updatingField === setting.key}
                                    checked={Boolean(trendsOrganization[setting.key])}
                                    onChange={handleToggle(setting.key)}
                                    sx={styles.switch}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
}

const style = {
    groups: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
    },
    group: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    groupTitle: {
        m: 0,
        fontSize: '14px',
        fontFamily: 'LarsseitMedium',
        color: '#495D5E',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
    },
    groupToggles: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    unavailable: {
        mt: '8px',
    },
    unavailableText: {
        fontSize: '15px',
        fontFamily: 'larsseitRegular',
        color: '#495D5E',
    },
};
